module.exports = __webpack_public_path__ + "coin_stack.b3ff37ab7816c96b6c2352758c4a7967.svg";